<div class="top-cont">
  <input
    type="checkbox"
    id="uploadDocument"
    [(ngModel)]="switchValue"
    (change)="fnOnToggleSwitch()"
  />

  <label for="uploadDocument">
    {{ buttonText }}
  </label>
</div>

<app-upload-dialog
  #uploadDialog
  [heading]="heading"
  [showNote]="showNote"
  [footerNote]="footerNote"
  (submitClick)="submitClick.emit($event)"
  (sampleDownload)="sampleDownload.emit()"
  (modalClosed)="switchValue = false"
>
</app-upload-dialog>